import { render, staticRenderFns } from "./FormControlMBasketOrdersQuantity.vue?vue&type=template&id=fc45a09a&scoped=true"
import script from "./FormControlMBasketOrdersQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketOrdersQuantity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMBasketOrdersQuantity.vue?vue&type=style&index=0&id=fc45a09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc45a09a",
  null
  
)

export default component.exports